import { useCurrentEnterpriseId } from '@mews-commander/core';
import { useRepositorySuspenseQuery } from '@mews-commander/data-access';

export const useActiveAccountingCategories = () => {
    const enterpriseId = useCurrentEnterpriseId();
    const query = useRepositorySuspenseQuery(
        'accountingCategories',
        'getAll',
        {
            enterpriseIds: [enterpriseId],
        },
        {
            select: ({ accountingCategories }) =>
                accountingCategories ? accountingCategories.filter(({ isActive }) => isActive) : [],
        }
    );

    return query.data;
};
